import { createSelector } from 'reselect';

export const selectDemById = (id) =>
  createSelector(
    (state) => state.Dems.dems,
    (dems) => {
      if (!id) return null;
      return dems.find((d) => d.id === id) || null;
    },
  );

export const selectSelectedDem = createSelector(
  (state) => state.Dems.selectedDem,
  (selectedDem) => selectedDem,
);

export const selectDemAiPanelOpen = createSelector(
  (state) => state.Dems.ai,
  (ai) => ai.isOpen,
);

export const selectDemAiMessages = createSelector(
  (state) => state.Dems.ai,
  (ai) => ai.messages,
);

export const selectDemAiLoading = createSelector(
  (state) => state.Dems.ai,
  (ai) => ai.loading,
);

export const selectDemAiError = createSelector(
  (state) => state.Dems.ai,
  (ai) => ai.error,
);
